import * as React from "react"
import { Link } from "gatsby"
import FooterData from "../content/footer.json";
import Logo from './logo';

const FooterLinks = (data) => {
  return (
    <div className="text-center">
      <h4 className="text-center mb-4">{data.title}</h4>
      <div>
        {data.items.map(i => (
          (
            <div className="mb-1">
              <Link to={i.url}>{i.text}</Link>
            </div>
          )
        ))}
      </div>
    </div>
  );
}

const HorizontalFooterLinks = ({ data }) => {
  return (
    <div className="flex flex-row justify-end text-center">
      {data.items.map(i => (
        (
          <span className="ml-4">
            <Link to={i.url}>{i.text}</Link>
          </span>
        )
      ))}
    </div>
  );
}

const Footer = ({ siteTitle }) => {
  return (
    <div>
      <div className="container flex flex-col text-primary-text text-center">
        <div className="flex flex-row justify-between items-center">
          <Logo inverse={true} />
          {FooterData.length === 1 && (
            (
              <div>
                <HorizontalFooterLinks data={FooterData[0]} />
              </div>
            )
          )}
        </div>
        {FooterData.length > 1 && (
          <div>
            <div className="h-px bg-primary-text my-4" />
            <div className="grid grid-cols-3 my-4">
              {FooterData.map(FooterLinks)}
            </div>
          </div>
        )}
        <div className="my-4 text-sm">
          © {new Date().getFullYear()} Goodway
        </div>
      </div>
    </div >
  )
};

export default Footer;
